<template>
    <div class="animated fadeIn">
        <div v-if="loading">
            <b-row>
                <b-col md="6">
                    <atom-spinner
                        :animation-duration="1000"
                        :size="60"
                        color="#ff1d5e"
                        class="float-right my-4"
                    />
                </b-col>
            </b-row>
        </div>
        <b-row v-else>
            <b-col>
                <b-col md="12">
                    <component-header
                        title="Attribute"
                        :isLoading="isLoading"
                        :hasSearch="true"
                        :hasReload="false"
                        @search-query="(val) => (filter = val)"
                        @reload-data="reloadData"
                        createButtonText="Create"
                        @create-press="onClickAddPermission"
                    />
                </b-col>
                <b-table
                    style="border-radius: 12px"
                    :dark="dark"
                    :hover="hover"
                    :striped="striped"
                    :bordered="bordered"
                    :small="small"
                    :fixed="fixed"
                    :items="filteredList"
                    :fields="captions"
                    :current-page="currentPage"
                    :per-page="perPage"
                    thead-class="header"
                    class="mt-3"
                    show-empty
                    :busy="loading"
                    @filtered="onFilter"
                >
                    <template slot="action" slot-scope="data">
                        <router-link
                            :to="{
                                name: 'ViewAttribute',
                                params: { id: data.item._id },
                            }"
                        >
                            <b-button
                                size="sm"
                                class="button-circle mr-2"
                                variant="primary"
                            >
                                <i class="fa fa-eye"></i>
                            </b-button>
                        </router-link>
                        <router-link
                            :to="{
                                name: 'AttributeForm',
                                params: { id: data.item._id },
                            }"
                        >
                            <b-button
                                size="sm"
                                class="button-circle mr-2"
                                style="background: #fe7b08; border: #fe7b08"
                                variant="primary"
                            >
                                <i class="fa fa-pencil edit"></i>
                            </b-button>
                        </router-link>
                        <b-button
                            size="sm"
                            class="button-circle"
                            variant="danger"
                            @click="deleteAttribute(data)"
                        >
                            <i class="fa fa-trash bin"></i>
                        </b-button>
                    </template>

                    <div slot="table-busy" class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Loading...</strong>
                    </div>
                </b-table>
                <div style="float: right">
                    <b-pagination
                        v-model="currentPage"
                        :per-page="perPage"
                        :total-rows="filterCount"
                        aria-controls="my-table"
                        prev-text="Prev"
                        next-text="Next"
                        hide-goto-end-buttons
                    ></b-pagination>
                </div>
                <!-- </b-card> -->
            </b-col>
        </b-row>
    </div>
</template>

<script>
import { shuffleArray } from "@/shared/utils";
import cTable from "../base/Table.vue";
import axios from "axios";
import { deleteAttribute } from "../../services/attribute.js";
import ebButton from "@/components/FormElements/Button";
import { AtomSpinner } from "epic-spinners";
import { Pagination } from "ant-design-vue";
import ComponentHeader from "@/components/componentNewHeader";

export default {
    name: "viewattribute",
    components: {
        cTable,
        ebButton,
        AtomSpinner,
        ComponentHeader,
    },
    data: () => {
        return {
            filterCount: 0,
            loading: false,
            items: [],
            tableFields: [
                {
                    key: "attributeName",
                    label: "Field Name",
                    sortable: true,
                },
                {
                    key: "attributeValueType",
                    label: "Type",
                    sortable: true,
                },
                {
                    key: "description",
                    label: "Description",
                    sortable: true,
                },
                {
                    key: "action",
                    label: "Action",
                },
            ],
            filter: "",
            caption: "Table",
            hover: true,
            striped: false,
            bordered: true,
            small: false,
            fixed: false,
            tableData: [],
            perPage: 10,
            loading: false,
            pageOptions: [5, 10, 15, 20, 25, 30],
            currentPage: 1,
            dark: false,
        };
    },
    methods: {
        onClickAddPermission() {
            this.$router.push({ name: "CreateAttribute" });
        },

        onFilter(list) {
            this.filterCount = list.length;
            this.currentPage = 1;
        },
        getRowCount() {
            return this.attributelist.length;
        },
        async deleteAttribute(data) {
            this.$swal({
                title: "Delete this attribute?",
                text: "Are you sure? You won't be able to revert this!",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Yes, Delete it!",
            }).then((result) => {
                if (result.value) {
                    this.$store
                        .dispatch("attribute/deleteAttribute", data.item._id)
                        .then(async (result) => {
                            if (result.status === 1) {
                                this.$swal({
                                    title: "Congratulation",
                                    text: "Attribute has been deleted Successfully",
                                    type: "success",
                                });
                                this.loading = true;
                                await this.$store
                                    .dispatch("attribute/getAttributesList")
                                    .catch((error) => {
                                        this.$toasted.error(error.message);
                                    });
                                this.loading = false;
                            } else {
                                this.$toasted.error(
                                    result.response.data.message
                                        ? result.response.data.message
                                        : result.response.statusText,
                                );
                            }
                        });
                }
            });
        },
    },
    mounted: function () {
        this.$nextTick(async function () {
            this.loading = true;
            await this.$store
                .dispatch("attribute/getAttributesList")
                .catch((error) => {
                    this.$toasted.error(error.message);
                });
            this.loading = false;
        });
    },
    computed: {
        totalRows() {
            return this.getRowCount();
        },
        captions() {
            return this.tableFields;
        },
        attributelist() {
            return this.$store.getters["attribute/GetAttributeList"];
        },
        filteredList() {
            const filter = this.filter.toLowerCase();
            return this.attributelist.filter((item) => {
                return (
                    item.attributeName +
                    item.description +
                    item.attributeValueType
                )
                    .toLowerCase()
                    .includes(filter);
            });
        },
    },
};
</script>
<style scoped>
.edit {
    color: #ffffff !important;
}
.bin {
    color: white !important;
}
.header-font {
    font-weight: 700;
    font-size: medium;
}
.float-right {
    float: right;
}
.input-group {
    width: 59%;
    left: 130%;
}
</style>
